import React from 'react';

const LoginLink = () => {
  return (
    <a
      className="account-visitor text-gray-900 text-sm font-semibold font-inter leading-tight no-underline"
      id="login-link"
      href="/login"
    >
      Login
    </a>
  );
};

export default LoginLink;
